import type { BookingDetailsParticipantAddress } from '../../domain/types'

function joinNonEmpty(values: string[]): string {
  return values
    .map(value => value.trim())
    .filter(Boolean)
    .join(' ')
}

export function formatParticipantAddress(address: BookingDetailsParticipantAddress): string {
  if (!address) {
    return ''
  }

  const street = joinNonEmpty([address.street, address.houseNumber, address.houseNumberAddition])
  const city = joinNonEmpty([address.postalCode, address.city])

  return [street, city].filter(Boolean).join(', ')
}
